import { Checkbox } from 'semantic-ui-react';
import { dataPrivacyActions } from '../../behavior/dataPrivacy';
import { compose } from 'redux';
import { useTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

type Props = {
  showPersonalData?: boolean;
  toggleDataPrivacy?: () => void;
};

const DataPrivacy = ({ showPersonalData, toggleDataPrivacy }: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <label className="whiteText">{t('header.show.private.data')}</label>
      <Checkbox
        toggle
        checked={showPersonalData}
        onChange={toggleDataPrivacy}
        className="customToggle"
      />
    </>
  );
};

const mapStateToProps = (state: any) => ({
  showPersonalData: state.dataPrivacy.showPersonalData,
});

const mapDispatchToProps = (dispatch: any) => ({
  toggleDataPrivacy: () => dispatch(dataPrivacyActions.toggleDataPrivacy()),
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(DataPrivacy) as React.FC<Props>;
